import moment from 'moment'
import objectPath from 'object-path'
import NumberFormat from 'react-number-format'
import FeatherIcon from 'feather-icons-react'
import { Badge, Col, Form, Image, Row } from 'react-bootstrap'
import { Avatar, Chip, Tooltip, Typography } from '@material-ui/core'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import { getBaseURL } from 'utility/httpClient.util'
import {
  checkIsEqual,
  checkIsNotEqual,
  compareTwoValue,
  formatNumber,
  getCheckValue,
  getFieldValue,
  getRowFieldValue,
  getTitleValue,
  isNumber,
  truncateDecimal,
} from 'designer/component/action/Data'
import parse from 'html-react-parser'
import { MATH_SYMBOLS } from 'designer/component/system/menu/condition/component/calculate/config'
import { getCalculateValue } from 'designer/component/action/Calculate'
import { isEmpty } from 'lodash'
import Icon from '../Icon'

// COLUMN VALUE

export const getDataValue = (column, rowData) => {
  if (!column?.field) return ''
  let {
    valueType = 'receive',
    type,
    typeField,
    defaultValue,
    field = '',
  } = column
  if (valueType === 'receive' || type === 'label') {
    let keys = field.split('.')
    let stringKey = []
    let isVerified = true
    let dataValue = objectPath.get(rowData, keys)
    if (dataValue === undefined && defaultValue !== undefined) {
      dataValue = defaultValue
    }
    if (typeField === 'calculate') {
      let { formula } = column
      let calculateKey = column.calculate
      let foundFormula = formula.find(({ key }) => key === calculateKey)
      if (foundFormula) {
        dataValue = updateCalculate({ rowData, foundFormula })
      }
    }
    keys.forEach((key) => {
      stringKey.push(key)
      let value = objectPath.get(rowData, stringKey)
      if (value === undefined) {
        isVerified = false
      }
    })
    if (isVerified) {
      if (dataValue) {
        if (Array.isArray(dataValue)) {
          if (
            !column.isJoinString &&
            typeField !== 'arrayToString' &&
            typeField !== 'multiField'
          ) {
            dataValue = JSON.stringify(dataValue)
          }
        } else if (
          typeof dataValue === 'object' &&
          typeField !== 'multiField'
        ) {
          dataValue = JSON.stringify(dataValue)
        }
      }
    }
    return dataValue
  }
  return column?.value
}

// ORDER NO

export const checkTableCondition = (
  designContext = {},
  column = {},
  rowValue,
) => {
  let { jsonForm } = designContext
  let formData = jsonForm?.formData || {}
  let datasourceValue = objectPath.get(designContext, `@datasource`) || {}
  let { conditions = [] } = column
  let foundValue = conditions.find((condition) => {
    let { value, valueCategory, valueType } = condition
    if (valueCategory === 'element') {
      let key = condition.value
      value = objectPath.get(formData, key)
    } else if (valueCategory === 'datasource') {
      let key = condition.value
      value = objectPath.get(datasourceValue, key)
    } else {
      value = condition.value
    }
    if (Array.isArray(value)) {
      let foundValue = value.find((item) => {
        let itemValue = objectPath.get(item, column.field)
        return checkIsEqual(rowValue, itemValue)
      })
      value = foundValue ? objectPath.get(foundValue, column.field) : foundValue
    } else if (value && typeof value === 'object') {
      value = objectPath.get(value, column.field)
    }
    if (valueType === 'emptyValue') {
      return isEmpty(rowValue)
    }
    if (valueType === 'hasValue') {
      return !isEmpty(rowValue)
    }
    if (valueType === 'notEqualValue') {
      return checkIsNotEqual(rowValue, value)
    }
    return checkIsEqual(rowValue, value)
  })
  return foundValue
}

const checkColor = (color) => {
  if (!color) return
  const colorTrim = color.trim()
  const RGB_RE =
    /^rgba?\(\s*(?:25[0-5]|2[0-4]\d|1?\d?\d)\s*,\s*(?:25[0-5]|2[0-4]\d|1?\d?\d)\s*,\s*(?:25[0-5]|2[0-4]\d|1?\d?\d)(?:\s*,\s*(?:0|1|0?\.\d+))?\s*\)$/i
  if (RGB_RE.test(colorTrim)) return colorTrim
  const HEX_WITH_HASH =
    /^#(?:[0-9a-f]{3}|[0-9a-f]{4}|[0-9a-f]{6}|[0-9a-f]{8})$/i
  if (HEX_WITH_HASH.test(colorTrim)) return colorTrim
  const HEX_PLAIN = /^(?:[0-9a-f]{3}|[0-9a-f]{4}|[0-9a-f]{6}|[0-9a-f]{8})$/i
  if (HEX_PLAIN.test(colorTrim)) return `#${colorTrim}`
  return colorTrim
}

export const createLabel = (designContext, column, rowValue, rowData) => {
  let foundValue = checkTableCondition(designContext, column, rowValue)
  let label = rowValue
  if (foundValue) {
    let hasStatus = objectPath.has(foundValue, 'changeToStatus')
    let { statusChipColor, changeToStatus, statusColor, chipColumn } =
      foundValue
    if (hasStatus) {
      label = changeToStatus
    }
    if (chipColumn) {
      let chipColumnValue = checkColor(objectPath.get(rowData, chipColumn))

      return (
        <Chip
          label={label}
          style={{
            backgroundColor: chipColumnValue,
            color: statusColor || 'white',
          }}
        />
      )
    }
    if (statusChipColor) {
      return (
        <Chip
          label={label}
          style={{
            backgroundColor: statusChipColor,
            color: statusColor || 'white',
          }}
        />
      )
    }
  }

  return label
}

export const renderOrderNumber = () => {
  return (rowData) => rowData?.tableData?.no || rowData?.['@seq']
}

export const renderLabel = ({ designContext, column }) => {
  return (rowData) => {
    if (typeof rowData === 'object') {
      let rowValue = getDataValue(column, rowData)
      let label = createLabel(designContext, column, rowValue, rowData)
      return label
    }
    return rowData
  }
}

// STRING

export const renderString = ({ designContext, column }) => {
  return (rowData) => {
    let value = getDataValue(column, rowData)
    if (column?.isJoinString) {
      let { joinString = '' } = column
      if (Array.isArray(value)) {
        let stringArray = []
        value.forEach((item) => {
          let itemValue = objectPath.get(item, '')
          stringArray.push(itemValue)
        })
        value = stringArray.join(joinString)
      }
    }
    if (column?.isWrapText) {
      let wrapLength = column?.wrapLength || 20
      let truncText =
        value && value.length > wrapLength
          ? value.substring(0, wrapLength) + '...'
          : value
      return (
        <Tooltip title={value}>
          <span
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {truncText}
          </span>
        </Tooltip>
      )
    }
    let label = createLabel(designContext, column, value, rowData)
    return label
  }
}

const getTextValue = (value) => {
  if (value === undefined || value === null) return ''
  if (Array.isArray(value) || typeof value === 'object') {
    return JSON.stringify(value)
  }
  return `${value}`
}

const getJsonDataValue = (value) => {
  if (typeof value === 'string') {
    try {
      let parseValue = JSON.parse(value)
      if (Array.isArray(parseValue) || typeof parseValue === 'object') {
        return parseValue
      }
    } catch (error) {
      return value
    }
  }
  return value
}

const getArrayDataValue = (value) => {
  if (Array.isArray(value)) return value
  let parseValue = getJsonDataValue(value)
  if (Array.isArray(parseValue)) return parseValue
  return value
}

const getPatternText = (pattern = [], value) => {
  let dataValue = getJsonDataValue(value)
  if (pattern.length === 0) return getTextValue(dataValue)
  return pattern
    .map(({ type = 'field', field = '', text = '', value = '' }) => {
      if (type === 'text') return text || value
      let itemValue = field ? objectPath.get(dataValue, field) : dataValue
      if (itemValue === undefined && field) {
        itemValue = objectPath.get(dataValue, [field])
      }
      if (itemValue === undefined && field?.includes('.')) {
        let keyList = field.split('.')
        let lastKey = keyList[keyList.length - 1]
        itemValue = objectPath.get(dataValue, lastKey)
      }
      return getTextValue(itemValue)
    })
    .join('')
}

const getArrayToStringItems = (column, rowData) => {
  let dataValue = getDataValue(column, rowData)
  let arrayData = getArrayDataValue(dataValue)
  if (!Array.isArray(arrayData)) {
    let textValue = getTextValue(arrayData)
    return textValue ? [textValue] : []
  }

  return arrayData
    .map((item) => {
      let { pattern = [] } = column.arrayToString || {}
      return getPatternText(pattern, item)
    })
    .filter((value) => value !== '')
}

export const getArrayToStringValue = (column, rowData) => {
  let { separator = ', ' } = column.arrayToString || {}
  return getArrayToStringItems(column, rowData)
    .join(separator)
}

export const renderArrayToString = ({ designContext, column }) => {
  return (rowData) => {
    let { displayType = 'text' } = column.arrayToString || {}
    if (displayType === 'badge') {
      let {
        badgeColor = '#6c757d',
        textColor = '#fff',
        fontSize = '12px',
        fontWeight = 'normal',
      } = column.arrayToString || {}
      let items = getArrayToStringItems(column, rowData)
      return (
        <span>
          {items.map((value, index) => (
            <Badge
              key={`array-to-string-badge-${index}`}
              className="mr-1 mb-1"
              style={{
                backgroundColor: badgeColor,
                color: textColor,
                fontSize,
                fontWeight,
                userSelect: 'none',
              }}
            >
              {value}
            </Badge>
          ))}
        </span>
      )
    }
    let value = getArrayToStringValue(column, rowData)
    let label = createLabel(designContext, column, value, rowData)
    return label
  }
}

const getMultiFieldValueItems = (value, pattern) => {
  let dataValue = getJsonDataValue(value)
  if (Array.isArray(dataValue)) {
    return dataValue
      .map((item) => getPatternText(pattern, item))
      .filter((value) => value !== '')
  }
  if (dataValue && typeof dataValue === 'object') {
    let textValue = getPatternText(pattern, dataValue)
    return textValue ? [textValue] : []
  }
  let textValue = getTextValue(dataValue)
  return textValue ? [textValue] : []
}

const getMultiFieldItems = (column, rowData) => {
  let { fields = [], pattern = [] } = column.multiField || {}
  return fields.reduce((items, fieldConfig = {}) => {
    let { field = '', value = '' } = fieldConfig
    let fieldKey = field || value
    if (!fieldKey) return items
    let fieldValue = objectPath.get(rowData, fieldKey)
    let valuePattern = objectPath.has(fieldConfig, 'pattern')
      ? fieldConfig.pattern
      : pattern
    let valueItems = getMultiFieldValueItems(fieldValue, valuePattern)
    return items.concat(valueItems)
  }, [])
}

export const getMultiFieldValue = (column, rowData) => {
  let { separator = ', ' } = column.multiField || {}
  return getMultiFieldItems(column, rowData)
    .join(separator)
}

export const renderMultiField = ({ designContext, column }) => {
  return (rowData) => {
    let { displayType = 'text' } = column.multiField || {}
    if (displayType === 'badge') {
      let {
        badgeColor = '#6c757d',
        textColor = '#fff',
        fontSize = '12px',
        fontWeight = 'normal',
      } = column.multiField || {}
      let items = getMultiFieldItems(column, rowData)
      return (
        <span>
          {items.map((value, index) => (
            <Badge
              key={`multi-field-badge-${index}`}
              className="mr-1 mb-1"
              style={{
                backgroundColor: badgeColor,
                color: textColor,
                fontSize,
                fontWeight,
                userSelect: 'none',
              }}
            >
              {value}
            </Badge>
          ))}
        </span>
      )
    }
    let value = getMultiFieldValue(column, rowData)
    let label = createLabel(designContext, column, value, rowData)
    return label
  }
}

// NUMERIC

export const renderNumeric = ({ column }) => {
  return (rowData) => {
    let value = getDataValue(column, rowData) ?? 0
    let { thousandSeparator, precision = 0 } = column
    let format = thousandSeparator
      ? formatNumber(value, precision)
      : truncateDecimal(value, precision, true)
    return format.toString()
  }
}

// CURRENCY

export const renderCurrency = ({ column }) => {
  return (rowData) => {
    let value = getDataValue(column, rowData)
    let currency = column.currency
    return (
      <NumberFormat
        name="value"
        thousandSeparator
        prefix={`${currency?.prefix ?? ''} `}
        autoComplete="off"
        value={value || 0}
        displayType={'text'}
      />
    )
  }
}

// DATE & TIME

export const renderDate = ({ column, formatDate }) => {
  let year = column.date ? column.date.year : 0
  let dateFormat = column.date ? column.date.format : 'YYYY-MM-DD'
  let formatType = column?.date?.formatType
  return (rowData) => {
    let value = getDataValue(column, rowData)
    let date = formatDate(moment(value))
    if (formatType === 'custom') {
      date = formatDate(moment(value), dateFormat)
    }
    return value ? (date === 'Invalid Date' ? '' : date) : ''
  }
}

export const renderTime = ({ column, formatTime }) => {
  let timeFormat = column.time ? column.time.format : 'HH:mm:ss'
  let checkHour = /(h)/.test(timeFormat)
  timeFormat = checkHour ? `${timeFormat} A` : timeFormat
  let formatType = column?.time?.formatType || 'system'
  return (rowData) => {
    let time
    let value = getDataValue(column, rowData)
    if (value) {
      let today = moment().format('YYYY-MM-DD')
      let dateTime = `${today} ${value}`
      if (moment(dateTime).format(timeFormat) === 'Invalid date') {
        if (moment(value).format(timeFormat) === 'Invalid date') {
          dateTime = null
        } else {
          dateTime = value
        }
      }

      if (formatType === 'custom') {
        time = formatTime(moment(dateTime), timeFormat)
      } else {
        time = formatTime(moment(dateTime))
      }
    }
    return time === 'Invalid Date' ? '' : time
  }
}

export const renderDateTime = ({ column, formatDateTime }) => {
  let dateTimeFormat =
    column.date && column.time
      ? `${column.date.format} ${column.time.format}`
      : 'YYYY-MM-DD HH:mm:ss'
  let checkHour = /(h)/.test(dateTimeFormat)
  dateTimeFormat = checkHour ? `${dateTimeFormat} A` : dateTimeFormat
  let formatType = column?.date?.formatType
  return (rowData) => {
    let value = getDataValue(column, rowData)
    let dateTime = formatDateTime(moment(value))
    if (formatType === 'custom') {
      dateTime = formatDateTime(moment(value), dateTimeFormat)
    }
    return value ? dateTime : ''
  }
}

// CHECKBOX

export const renderCheckbox = ({ column }) => {
  return (rowData) => {
    let value = getDataValue(column, rowData)
    let valueChecked = objectPath.get(column, 'checkbox.checked')
    valueChecked = isNumber(valueChecked) ? Number(valueChecked) : valueChecked
    const checked = valueChecked === value
    return (
      <Form.Control
        type="checkbox"
        style={{ width: '18px', height: '18px' }}
        checked={checked}
      />
    )
  }
}

// ACTIVE

export const renderActive = ({ column }) => {
  return (rowData) => {
    let value = getDataValue(column, rowData)
    return column.status?.active === value ? (
      <Badge variant="success">Active</Badge>
    ) : (
      <Badge variant="danger">Inactive</Badge>
    )
  }
}

// STATUS

export const createStatus = (column, value) => {
  let { mapIcon = [], defaultIcon = {} } = column

  let found = mapIcon.find((item) => {
    let itemValue = item.value
    let newValue = value
    itemValue = getCheckValue(itemValue)
    newValue = getCheckValue(newValue)
    return compareTwoValue('equalValue', itemValue, newValue)
  })

  let iconColor = found?.iconColor ?? defaultIcon?.iconColor
  let chipColor = found?.chipColor ?? defaultIcon?.chipColor
  let foundText = found?.text || ''
  let defaultText = defaultIcon?.text || ''
  let replaceValue = foundText || defaultText || value

  if (found?.iconSource) {
    if (foundText) {
      return (
        <Chip
          label={
            <div className="d-flex align-items-center">
              <Icon iconName={found?.icon} size="12" />
              <span className="ml-1">{foundText}</span>
            </div>
          }
          style={{
            backgroundColor: chipColor,
            color: iconColor || 'white',
            height: '25px',
          }}
        />
      )
    }
    return (
      <Icon
        iconName={found?.icon}
        style={{ color: iconColor || 'darkgray' }}
        size="20"
      />
    )
  }
  if (found?.icon) {
    if (foundText) {
      return (
        <Chip
          label={
            <div className="d-flex align-items-center">
              <FeatherIcon icon={found?.icon} size="12" className="mr-1" />
              <span className="ml-1">{foundText}</span>
            </div>
          }
          style={{
            backgroundColor: chipColor,
            color: iconColor || 'white',
            height: '25px',
          }}
        />
      )
    }

    return (
      <FeatherIcon
        icon={found?.icon}
        style={{ color: iconColor || 'darkgray' }}
        size="20"
      />
    )
  }
  if (chipColor) {
    return (
      <Chip
        label={replaceValue}
        style={{
          backgroundColor: chipColor,
          color: iconColor || 'white',
          height: '25px',
        }}
      />
    )
  }
  return replaceValue ?? ''
}

const getStatusDataValue = (column, dataValue) => {
  let { isMapSplitValue, splitValue = '' } = column

  if (!isMapSplitValue || Array.isArray(dataValue) || !splitValue) {
    return dataValue
  }

  if (dataValue === undefined || dataValue === null) {
    return dataValue
  }

  if (typeof dataValue !== 'string') {
    return dataValue
  }

  return dataValue.split(splitValue).map((value) => value.trim())
}

const createRenderStatus = (rowData, column) => {
  let dataValue = getStatusDataValue(
    column,
    objectPath.get(rowData, column.field),
  )
  let isExcludeEmpty = column?.isExcludeEmpty

  if (Array.isArray(dataValue)) {
    return (
      <Row className="px-2">
        {dataValue.map((value, index) => {
          if (typeof value === 'object') {
            if (objectPath.get(value, 'value')) {
              value = objectPath.get(value, 'value')
            } else {
              value = JSON.stringify(value)
            }
          }

          if (isEmpty(value) && isExcludeEmpty) return ''
          return (
            <Col key={index} sm="auto" className="px-1 pt-1 pb-0">
              {createStatus(column, value)}
            </Col>
          )
        })}
      </Row>
    )
  }

  if (isEmpty(dataValue) && isExcludeEmpty) return ''

  return createStatus(column, dataValue)
}

export const renderStatus = ({ column, isEditable }) => {
  if (isEditable) {
    return (editProps) => {
      let rowData = editProps?.rowData || editProps
      return createRenderStatus(rowData, column)
    }
  }
  return (rowData) => {
    return createRenderStatus(rowData, column)
  }
}

// IMAGE

export const renderImage = ({ column }) => {
  return (rowData) => {
    let value = getDataValue(column, rowData)
    let style = {
      width: column.imageWidth ?? '50px',
      height: column.imageHeight ?? '50px',
      objectFit: 'cover',
    }
    return value ? <Image src={value} style={style} /> : ''
  }
}

// MEDIA

export const renderMediaId = ({ column }) => {
  const baseUrl = getBaseURL()

  return (rowData) => {
    let mediaId = getDataValue(column, rowData)
    let profileSrc = `${baseUrl}/media/attachment/thumbnail/${mediaId}`
    return (
      <Avatar
        src={profileSrc}
        style={{
          width: column.imageWidth ?? '50px',
          height: column.imageHeight ?? '50px',
        }}
        variant={column.variant}
      />
    )
  }
}

// SELECT

export const getOptionLabel = (option, optionLabel) => {
  if (Array.isArray(optionLabel)) {
    let labelString = []
    let isAll = option?.isAll
    if (isAll) {
      return option?.label
    } else {
      optionLabel.forEach(({ value, __isNew__ }) => {
        if (__isNew__) {
          labelString.push(value)
        } else {
          let label = objectPath.get(option, value)
          labelString.push(label)
        }
      })
      return labelString.join('')
    }
  }
  return objectPath.get(option, optionLabel) || ''
}

const checkValue = (value) => {
  if (value === true) {
    return 'true'
  }
  if (value === false) {
    return 'false'
  }
  if (value === null) {
    return 'null'
  }
  if (value === undefined) {
    return 'undefined'
  }
  if (isNumber(value)) {
    return Number(value)
  }
  return value
}

export const createOptions = (designContext, column, optionData) => {
  let {
    isAll,
    allLabel,
    allValue,
    optionValue,
    titleValue,
    joinTitle = '',
  } = optionData
  let options = isAll
    ? [
        {
          label: allLabel,
          [optionValue]: allValue,
          isAll: true,
        },
      ]
    : []

  const { selectApiOption } = designContext
  let { optionType } = column
  let { url } = objectPath.get(column, `${optionType}`) || {}
  let selectOption = null
  if (url) {
    selectOption = objectPath.get(selectApiOption, url)
  }
  if (selectOption) {
    options = options.concat(selectOption)
  } else if (Array.isArray(optionData?.options)) {
    options = options.concat(optionData.options)
  } else if (optionData?.options && typeof optionData?.options === 'object') {
    let keyList = Object.keys(optionData.options)
    let newList = []
    keyList.forEach((key) => {
      let item = {
        label: key,
        [optionValue]: objectPath.get(optionData.options, key),
      }
      newList.push(item)
    })
    options = options.concat(newList)
  }
  if (titleValue) {
    options.map((option) => {
      let titleList = []
      let labelList = []
      let fontColor = ''
      let fontWeight = ''
      let isLockedSelect
      titleValue.forEach(
        ({ title, replaceValues, fontWeight: titleFontWeight }) => {
          let itemFontColor = ''
          let itemFontWeight = titleFontWeight || ''
          let subTitle = []
          title.forEach((title) => {
            let labelValue = title.value
            let hasValue = objectPath.has(option, title.value)
            if (hasValue) {
              labelValue = objectPath.get(option, title.value)
              if (replaceValues) {
                let foundReplace = replaceValues.find(({ value }) => {
                  let aValue = checkValue(labelValue)
                  let bValue = checkValue(value)
                  return aValue === bValue
                })
                if (foundReplace) {
                  let { replace } = foundReplace
                  labelValue = replace
                  itemFontColor = foundReplace.fontColor
                  itemFontWeight = foundReplace.fontWeight || titleFontWeight
                  isLockedSelect = foundReplace.isLockedSelect
                }
              }
            }
            subTitle.push(labelValue)
          })
          let label = subTitle.join('')
          fontColor = itemFontColor || fontColor
          fontWeight = itemFontWeight || fontWeight
          titleList.push(label)
          labelList.push({
            label,
            fontColor: itemFontColor,
            fontWeight: itemFontWeight,
          })
        },
      )
      let labelValue = titleList.join(joinTitle)
      objectPath.set(option, '@isUseTitleValue', true)
      objectPath.set(option, '@label', labelValue)
      objectPath.set(option, '@labelList', labelList)
      objectPath.set(option, '@fontColor', fontColor)
      objectPath.set(option, '@fontWeight', fontWeight)
      if (isLockedSelect) {
        objectPath.set(option, 'isDisabled', fontColor)
      }
      return option
    })
  }
  return options
}

export const renderSelect = ({ designContext, column }) => {
  let { optionType } = column
  let optionData = objectPath.get(column, `${optionType}`) || {}
  let optionLabel = objectPath.get(optionData, 'optionLabel') || 'label'
  let optionValue = objectPath.get(optionData, 'optionValue') || 'value'
  let options = createOptions(designContext, column, optionData)

  return (rowData) => {
    let value = getDataValue(column, rowData)
    let found = options.find((option) => {
      let valueOption = option[optionValue]
      return getCheckValue(valueOption) === getCheckValue(value)
    })
    if (found) {
      let value
      let isUseTitleValue = objectPath.get(found, `@isUseTitleValue`)
      if (isUseTitleValue) {
        value = objectPath.get(found, `@label`)
      } else {
        value = getOptionLabel(found, optionLabel)
      }
      let label = createLabel(designContext, column, value, rowData)
      return label
    }
    return value
  }
}

export const renderAutocomplete = ({ column }) => {
  return (rowData) => {
    let { optionType, field } = column
    let { optionValue } = objectPath.get(column, `${optionType}`)
    let value = objectPath.get(rowData, field)
    if (!objectPath.has(rowData, optionValue)) {
      objectPath.set(rowData, optionValue, value)
    }
    return getRowFieldValue(column, rowData)
  }
}

export const renderUser = ({ designContext, column }) => {
  let optionValue = column?.type || column?.typeField
  let options = designContext?.employeeList || []
  return (rowData) => {
    let value = objectPath.get(rowData, column.field)
    if (value === undefined) {
      value = getDataValue(column, rowData)
    }
    let label
    if (value && typeof value === 'object') {
      label = objectPath.get(value, 'fullName') || objectPath.get(value, 'label')
      value =
        objectPath.get(value, optionValue) ||
        objectPath.get(value, 'value') ||
        objectPath.get(value, 'userId') ||
        objectPath.get(value, 'employeeCode')
    }
    let found = options.find((option) => {
      let valueOption = option[optionValue]
      return getCheckValue(valueOption) === getCheckValue(value)
    })
    return found?.fullName || label || value
  }
}

export const renderHtml = ({ column }) => {
  return (rowData) => {
    let dataValue = objectPath.get(rowData, column.field)
    if (Array.isArray(dataValue)) {
      return (
        <Row>
          {dataValue.map((value, index) => {
            if (typeof value === 'object') {
              if (objectPath.get(value, 'value')) {
                value = objectPath.get(value, 'value')
              } else {
                value = JSON.stringify(value)
              }
            }
            return <Col key={index} sm="12">{parse(value)}</Col>
          })}
        </Row>
      )
    }
    return dataValue ? parse(dataValue) : ''
  }
}

export const renderJsonForm = ({ column }) => {
  return (rowData) => {
    let value = objectPath.get(rowData, column.field)
    const { iconColor = '#000' } = column?.jsonForm || {}
    if (value) {
      return <OpenInNewIcon style={{ cursor: 'pointer', color: iconColor }} />
    }
    return ''
  }
}

export const updateCalculate = ({ rowData, formData, foundFormula }) => {
  let result = 0
  let formulaData = foundFormula.data
  let formulaLink = foundFormula.symbol
  formulaData.forEach((formula, formulaIndex) => {
    let formulaValue = 0
    formulaValue = getCalculateValue(formula, formulaValue, {
      rowData,
      formData,
    })
    if (formulaIndex === 0) {
      result = formulaValue
    } else {
      let symbol = objectPath.get(formulaLink, formulaIndex - 1)
      let foundSymbol = MATH_SYMBOLS.find((math) => math.symbol === symbol)
      if (foundSymbol) {
        let { calculate } = foundSymbol
        result = calculate(result, formulaValue)
      }
    }
  })
  return Math.round(result * 100) / 100
}

export const renderCalculate = ({ designContext, column }) => {
  let { jsonForm } = designContext
  let formData = jsonForm.formData
  let { formula = [], thousandSeparator, precision = 0 } = column
  let calculateKey = column.calculate
  let foundFormula = formula.find(({ key }) => key === calculateKey)

  return (rowData) => {
    if (foundFormula) {
      let calValue = updateCalculate({ rowData, formData, foundFormula })
      let format = thousandSeparator
        ? formatNumber(calValue, precision)
        : truncateDecimal(calValue, precision, true)
      return format.toString()
    }
    return ''
  }
}
